function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "6.8,100.1 1.3,94.1 47.9,51.5 1.3,7 6.9,1.1 59.8,51.7  "
}), React.createElement("path", {
  className: "st0",
  d: "M8.2,8.2h134.2V93H8.2V8.2z M0,101.2h150.5V0H0V101.2z"
}), React.createElement("polygon", {
  className: "st0",
  points: "143.9,100.1 90.9,49.5 143.9,1.1 149.4,7.1 102.9,49.6 149.5,94.2  "
}), React.createElement("polygon", {
  className: "st0",
  points: "73.6,76.2 1.3,7 6.9,1.1 73.8,65 143.7,1.1 149.2,7.1  "
}));

var SvgEnvelope = function SvgEnvelope(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150.5 101.2",
    style: {
      enableBackground: "new 0 0 150.5 101.2"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/envelope.7761c86c.svg";
export { SvgEnvelope as ReactComponent };